import { Theme } from "@mui/material";

export const getStyles = (theme: Theme, color?: string) => ({
  box: {
    width: 8,
    height: 8,
    borderRadius: "50%",
    backgroundColor: color ?? theme.palette.transparent.pure,
    marginRight: 4,
  },

  boxSquere: {
    width: 10,
    height: 10,
    backgroundColor: color ?? theme.palette.transparent.pure,
    marginRight: 4,
  },

  iconBox: {
    width: 16,
    height: 16,
    borderRadius: "50%",
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.background.paper,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  icon: {
    width: 14,
    height: 14,
    color: theme.palette.background.paper,
  },

  weather: {
    fontFamily: "weathericons",
  },

  textPrimary: {
    color: theme.palette.text.primary,
  },

  textPrimaryBold: {
    color: theme.palette.text.primary,
    fontWeight: theme.typography.fontWeightBold,
  },

  textPrimaryLargeBold: {
    color: theme.palette.text.primary,
    fontSize: theme.fontSizes.lg,
    fontWeight: theme.typography.fontWeightBold,
  },

  textSecondary: {
    color: theme.palette.text.secondary,
  },

  textSecondaryBold: {
    color: theme.palette.text.secondary,
    fontWeight: theme.typography.fontWeightBold,
  },

  diff: {
    color: color,
    fontWeight: theme.typography.fontWeightBold,
  },

  row: {
    display: "flex",
    alignItems: "center",
  },

  expectedVisitors: {
    display: "flex",
    marginTop: 8,
    alignItems: "center",
  },

  rowStart: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: 4,
  },

  rowEnd: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: 4,
  },

  expectedVisitorsNumber: {
    color: theme.palette.primary.main,
    fontSize: theme.fontSizes.md,
    fontWeight: theme.typography.fontWeightBold,
    marginLeft: 4,
  },

  expectedVisitorsText: {
    color: theme.palette.text.primary,
    fontSize: theme.fontSizes.sm,
    marginLeft: 4,
  },

  popupRow4Cols: {
    display: "grid",
    alignItems: "center",
    gap: 8,
    lineHeight: 1.2,
    marginTop: 8,
    gridTemplateColumns: "6fr 3fr 2fr 2fr",
  },

  popupRow3Cols: {
    display: "grid",
    alignItems: "center",
    gap: 8,
    lineHeight: 1.2,
    marginTop: 8,
    gridTemplateColumns: "6fr 3fr 2fr 2fr",
  },

  popupRow2Cols: {
    display: "grid",
    alignItems: "center",
    gap: 8,
    lineHeight: 1.2,
    marginTop: 8,
    gridTemplateColumns: "3fr 1fr",
  },

  popupRowEvent: {
    display: "grid",
    alignItems: "center",
    gap: 8,
    lineHeight: 1.2,
    marginTop: 8,
    gridTemplateColumns: "2fr 7fr 2fr 2fr",
  },

  popupCol: {
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },

  popupColRight: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: 4,
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },

  popupColLeft: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: 4,
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },
});
